import { parse } from 'date-fns';

/**
 * Parse string into Date object or throw error.
 * @param dateString Format: `yyyy-MM-dd`
 */
function parseDate(dateString: string): Date {
  if (!dateString.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
    throw new Error('Invalid date format on <parseString>. Expected: yyyy/MM/dd, eg: 2021/12/31');
  }

  const parsedDate = parse(dateString, 'yyyy/MM/dd', new Date());

  if (isNaN(parsedDate.getDate())) {
    throw new Error('Invalid date on <parseString>. Check date range.');
  }

  return parsedDate;
}

/**
 * Transform string into Date object or null.
 * Made to be used with `Yup.date().transform()`
 * @param originalValue Format: `yyyy-MM-dd`
 */
function transformDate(originalValue: string): Date | null {
  try {
    return parseDate(originalValue);
  } catch (err) {
    return null;
  }
}

function formatDateToYYYYMMDD(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Mês começa em 0 (janeiro).
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}/${month}/${day}`;
}

/**
 * Format an API date for masked inputs (`yyyy/MM/dd`) without timezone conversion.
 * Accepts `yyyy-MM-dd`, `yyyy/MM/dd`, or an ISO datetime whose calendar date is in the prefix.
 */
function formatApiDateToInput(value?: string | Date | null): string {
  if (!value) {
    return '';
  }

  if (value instanceof Date && !isNaN(value.getTime())) {
    const year = value.getUTCFullYear();
    const month = String(value.getUTCMonth() + 1).padStart(2, '0');
    const day = String(value.getUTCDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  const match = String(value).match(/^(\d{4})[-/](\d{2})[-/](\d{2})/);
  if (match) {
    return `${match[1]}/${match[2]}/${match[3]}`;
  }

  return '';
}

export { parseDate, transformDate, formatDateToYYYYMMDD, formatApiDateToInput };
